import { useWebsite } from '../../hooks/useWebsite';

export function useHasImage() {
  return !!useWebsite().graphdebate?.edition?.upload;
}

export function useHasEmoji() {
  const { emoticons } = useWebsite().graphdebate?.edition || {};
  return !!emoticons;
}

export function useHasFormatting() {
  const { graphdebate = {} } = useWebsite();
  const { edition = {} } = graphdebate ?? {};
  const { formatting: canFormat } = edition ?? {};

  return !!canFormat;
}

export function useHasEditorOptionButtons() {
  const hasImage = useHasImage();
  const hasEmoji = useHasEmoji();
  const hasFormatting = useHasFormatting();

  return hasImage || hasEmoji || hasFormatting;
}
